/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".ro-form-control-errors label.uk-form-label{color:var(--tw-red-500)}  .ro-form-control-errors input{border-color:var(--tw-red-500)!important;background:rgba(var(--tw-red-500-values),.1)!important;color:var(--tw-red-500)!important}"];
export { styles as styles };
